"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _leaflet = require("leaflet");

var _logo_placeholder = _interopRequireDefault(require("../images/logo_placeholder.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RelationModel = function RelationModel(json, relation, lang) {
  var result = [];
  var newBounds = (0, _leaflet.latLngBounds)(); // seemed to work without having to pass init arg

  var relation_types = [];
  var object = new Object();
  object.data = new Object();
  object.data.id = json.number;
  object.data.vat = json.search_id;
  object.data.zoomed = false;
  object.data.enterprise_name = json.from_enterprise["official_name_".concat(lang)] || json.from_enterprise.official_name_nl || json.from_enterprise.official_name_fr || json.from_enterprise.official_name_de || json.from_enterprise.official_name_en;
  object.data.establishment_name = json.from_enterprise["name_".concat(lang)] || json.from_enterprise.name_nl || json.from_enterprise.name_fr || json.from_enterprise.name_de || json.from_enterprise.name_en;
  object.data.address = new Object();
  object.data.address.lat = json.address.latitude ? json.address.latitude : 0;
  object.data.address["long"] = json.address.longitude ? json.address.longitude : 0;
  var streetname = json.address["streetname_".concat(lang)] || json.address.streetname_nl || json.address.streetname_fr || json.address.streetname_de || json.address.streetname_en;
  var house_number = json.address.house_number;
  var box_number = json.address.box_number;
  var postal_code = json.address.postal_code;
  var municipality = json.address["municipality_".concat(lang)] || json.address.municipality_nl || json.address.municipality_fr || json.address.municipality_de || json.address.municipality_en;
  var submunicipality = json.address["sub_municipality_".concat(lang)] || json.address.sub_municipality_nl || json.address.sub_municipality_fr || json.address.sub_municipality_de || json.address.sub_municipality_en;
  object.data.address.line_1 = "".concat(streetname, " ").concat(house_number).concat(box_number !== '' ? " ".concat(box_number) : '');
  object.data.address.line_2 = "".concat(postal_code, " ").concat(submunicipality ? submunicipality : municipality, " ").concat(municipality ? submunicipality && submunicipality !== municipality ? "(".concat(municipality, ")") : "" : ""); // object.data.index = index

  object.data.logos = []; // function getRandomColor() {
  //     var letters = '0123456789ABCDEF';
  //     var color = '#';
  //     for (var i = 0; i < 6; i++) {
  //         color += letters[Math.floor(Math.random() * 16)];
  //     }
  //     return color;
  // }

  var to_description = relation.to_description["description_".concat(lang)] || relation.to_description.description_nl || relation.to_description.description_fr || relation.to_description.description_de || relation.to_description.description_en;
  var itemColor = relation.color;

  if (relation_types.filter(function (e) {
    return e.title === to_description;
  }).length === 0) {
    relation_types.push({
      title: to_description,
      color: itemColor // color: getRandomColor()

    });
  } // relation_types.map(type => {
  //     if (type.title === to_description) {
  //         itemColor = type.color
  //     }
  // })


  if (json.logolinks.length > 0) {
    json.logolinks.forEach(function (logo) {
      var logoItem = new Object();
      logoItem.logo = logo["png_".concat(lang)] || logo.png_nl || logo.png_fr || logo.png_de || logo.png_en;
      logoItem.color = itemColor;
      object.data.logos.push(logoItem);
    });
  } else {
    var logoItem = new Object();
    logoItem.logo = _logo_placeholder["default"];
    logoItem.color = itemColor;
    object.data.logos.push(logoItem);
  } // if (object.data.address.lat && object.data.address.long){


  newBounds.extend([object.data.address.lat, object.data.address["long"]]); // }

  return {
    object: object,
    newBounds: newBounds,
    relation_types: relation_types
  };
};

var _default = RelationModel;
exports["default"] = _default;